import * as React from "react"
import { SVGProps } from "react"

const DownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 1 7 7 1 1"
      stroke="#9DA3B7"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default DownArrow
